import { render, staticRenderFns } from "./dedicated-requests.vue?vue&type=template&id=e85f6f4c"
import script from "./dedicated-requests.vue?vue&type=script&lang=js"
export * from "./dedicated-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports